import InputControl from './input_control';
import SelectControl from './select_control';

export default {
  InputControl,
  SelectControl,
};
